<template>
    <v-container flat style="max-width: 950px">
        <div v-if="ofx && step > 1 && ofxCounter.length > 1" class="d-flex justify-end px-4">
            <h3>{{ `${ofxCounter.current}/${ofxCounter.length}` }}</h3>
        </div>
        <v-row no-gutters v-if="step === 1 || step === 2" class="pt-4 d-flex align-center">
            <v-col class="px-6" cols="auto">
                <h2>Compte associé</h2>
            </v-col>

            <v-col cols="auto" class="px-6">
                <v-select-filled
                    density="compact"
                    v-model="bankAccount"
                    :items="bankAccounts"
                    label="Compte bancaire"
                    item-title="name"
                    item-value="id"
                    return-object
                    hide-details
                    min-width="200px"
                />
            </v-col>
        </v-row>
        <div v-if="emptyMessage !== '' && step > 1">
            <v-alert :value="true" type="warning">{{ emptyMessage }}</v-alert>
        </div>
        <div v-if="wrongFormat">
            <v-alert :value="true" type="error"
                >Ce fichier n'est pas au bon format. Veuillez choisir un autre fichier.</v-alert
            >
        </div>
        <div v-if="foundErrors.length">
            <v-alert :value="true" type="error">{{ errorDescription }}</v-alert>
        </div>
        <v-window v-model="step" touchless>
            <v-window-item :value="0" class="py-3">
                <UploadDocuments
                    :companyId="selectedCompany && selectedCompany.id ? selectedCompany.id : null"
                    :showFirstPrevious="false"
                    :documentType="'BANK_STATEMENT'"
                    :inExtensions="extensions"
                    :multiple="false"
                    :freeTag="false"
                    :gDrive="false"
                    :dBox="false"
                    @fileInput="onFileChanged"
                    @fileDeleted="onFileDeleted"
                    @testFileInput="onTestFileChanged"
                />
            </v-window-item>
            <v-window-item :value="1" style="width: 900px">
                <ColumnCorrespondence
                    ref="columnComponent"
                    v-if="step > 0 && existingFile && !ofx"
                    :result="result"
                    :extension="extension"
                    :ignoreHeaders="scanBank"
                    :actions="actions"
                    :ruleManager="ruleManager"
                    :formatColumns="formatColumns"
                    :requireDateVerification="true"
                    :updateAccountingDates="true"
                    :validateAccountingDates="true"
                    :preProcessFunction="processBankTransaction"
                    @columns-chosen="onChosenColumns($event)"
                    @back="step = 0"
                />
            </v-window-item>
            <v-window-item :value="2">
                <v-card class="default_card large" elevation="0">
                    <v-row no-gutters class="d-flex justify-center">
                        <v-col cols="12">
                            <v-list two-line style="background-color: transparent">
                                <v-virtual-scroll
                                    :item-height="75"
                                    :items="importedItems"
                                    height="450"
                                    class="py-3"
                                >
                                    <template v-slot:default="{ item }">
                                        <div class="pb-1">
                                            <v-list-item
                                                :key="item.key"
                                                inactive
                                                class="oss-list-item"
                                            >
                                                <v-row no-gutters>
                                                    <v-col cols="1" class="d-flex align-center">
                                                        <v-checkbox-btn
                                                            color="primary"
                                                            @update:model-value="select(item)"
                                                            :ripple="false"
                                                            :model-value="isSelected(item)"
                                                        />
                                                    </v-col>
                                                    <v-col cols="8">
                                                        <v-row
                                                            no-gutters
                                                            class="d-flex align-center"
                                                        >
                                                            <v-col
                                                                cols="12"
                                                                class="d-flex pb-2 font-weight-bold align-center"
                                                            >
                                                                <v-icon
                                                                    icon="$label"
                                                                    large
                                                                    left
                                                                    color="green"
                                                                />
                                                                <template
                                                                    v-if="
                                                                        item.connectPattern &&
                                                                        item.pattern &&
                                                                        item.pattern.rules &&
                                                                        item.pattern.rules
                                                                            .outputWording
                                                                    "
                                                                >
                                                                    {{
                                                                        item.pattern.rules
                                                                            .outputWording
                                                                    }}
                                                                </template>
                                                                <template v-else>
                                                                    {{
                                                                        item["wording"].substring(
                                                                            0,
                                                                            100,
                                                                        )
                                                                    }}
                                                                </template>
                                                            </v-col>
                                                            <v-col
                                                                cols="3"
                                                                class="px-1 d-flex align-center"
                                                            >
                                                                <v-icon
                                                                    icon="$euro"
                                                                    small
                                                                    left
                                                                    color="green"
                                                                />
                                                                {{ getAmount(item) }}
                                                            </v-col>
                                                            <v-col
                                                                cols="3"
                                                                class="px-1 d-flex align-center"
                                                            >
                                                                <v-icon
                                                                    color="green"
                                                                    size="small"
                                                                    location="start"
                                                                    >$oss-calendar</v-icon
                                                                >{{ item["date"] }}
                                                            </v-col>
                                                            <v-col
                                                                cols="3"
                                                                class="px-1 d-flex align-center"
                                                                v-if="positions.dateRealization"
                                                            >
                                                                <v-icon
                                                                    icon="$fa-hourglass-half"
                                                                    small
                                                                    left
                                                                    color="secondary"
                                                                />
                                                                {{ item["dateRealization"] }}
                                                            </v-col>
                                                            <v-col
                                                                cols="3"
                                                                class="d-flex px-1 align-center"
                                                            >
                                                                <p
                                                                    v-if="
                                                                        item.pattern &&
                                                                        item.pattern.rules
                                                                            .accountableAccount
                                                                    "
                                                                    :class="
                                                                        item.connectPattern
                                                                            ? ''
                                                                            : 'text-decoration-line-through'
                                                                    "
                                                                >
                                                                    Compte Comptable :
                                                                    {{
                                                                        item.pattern.rules
                                                                            .accountableAccount.name
                                                                    }}
                                                                </p>
                                                                <p
                                                                    v-if="
                                                                        item.pattern &&
                                                                        item.pattern.rules
                                                                            .thirdPartyAccountableAccount
                                                                    "
                                                                    :class="
                                                                        item.connectPattern
                                                                            ? ''
                                                                            : 'text-decoration-line-through'
                                                                    "
                                                                >
                                                                    Compte de Tiers :
                                                                    {{
                                                                        item.pattern.rules
                                                                            .thirdPartyAccountableAccount
                                                                            .name
                                                                    }}
                                                                </p>
                                                                <p
                                                                    v-if="
                                                                        item.pattern &&
                                                                        item.pattern
                                                                            .thirdPartyCompany &&
                                                                        item.pattern
                                                                            .thirdPartyCompany.name
                                                                    "
                                                                    :class="
                                                                        item.connectPattern
                                                                            ? ''
                                                                            : 'text-decoration-line-through'
                                                                    "
                                                                >
                                                                    Société :
                                                                    {{
                                                                        item.pattern
                                                                            .thirdPartyCompany.name
                                                                    }}
                                                                </p>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col cols="1">
                                                        <v-tooltip
                                                            v-if="invalidDate(item)"
                                                            location="end"
                                                        >
                                                            <template #activator="{ props }">
                                                                <b v-bind="props">
                                                                    <v-icon
                                                                        icon="$error"
                                                                        color="error"
                                                                        v-if="invalidDate(item)"
                                                                    />
                                                                </b>
                                                            </template>
                                                            <span
                                                                >La transaction est antérieure à la
                                                                date<br />autorisée et ne sera pas
                                                                importée.</span
                                                            >
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col
                                                        cols="2"
                                                        v-if="item.pattern"
                                                        class="d-flex align-center justify-end"
                                                    >
                                                        Appliquer l'analyse
                                                        <v-checkbox
                                                            class="ml-1"
                                                            v-model="item.connectPattern"
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </v-list-item>
                                        </div>
                                    </template>
                                </v-virtual-scroll>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-card>
            </v-window-item>
            <v-window-item :value="3">
                <v-card class="default_card large" elevation="0">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-list-item class="oss-list-item ma-2" :active="false" :link="false">
                                <v-list-item-title>
                                    <v-row no-gutters class="pb-4">
                                        <v-col class="d-flex justify-center">
                                            <h2>Ajout de solde bancaire - Optionnel</h2>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters class="pb-4">
                                        <v-col class="d-flex justify-center">
                                            Opérations bancaires importées (du
                                            {{ formatDate(minDate) }} au&nbsp
                                            <b>{{ formatDate(maxDate) }}</b
                                            >)
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters justify="space-around">
                                        <!-- <v-col cols="2" class="d-flex align-center ">
                                                    Solde au
                                                </v-col> -->
                                        <v-col cols="4" class="pt-2">
                                            <oss-date-picker-filled
                                                v-model="balanceDate"
                                                :required="true"
                                                :hideDetails="true"
                                                :textFieldReadOnly="false"
                                                prefixDataCy="bankTransactionImportCSV-"
                                                :showCurrent="maxDate"
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pt-2 pb-2">
                                            <oss-text-field-filled
                                                label="Solde relevé"
                                                outlined
                                                density="compact"
                                                :required="true"
                                                :hide-details="true"
                                                append-inner-icon="$euro"
                                                data-cy="bankTransactionImportCSV-balance"
                                                v-model="balance"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-list-item-title>
                                <v-list-item-subtitle />
                            </v-list-item>
                        </v-col>
                    </v-row>
                </v-card>
            </v-window-item>
        </v-window>

        <!-- <v-card-actions v-if="fileName && step !== 0">
            <v-btn
                class="btn"
                rounded
                 size="small"
                color="secondary"
                :disabled="step === 0"
                @click="step --"
            >
                Précédent
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                class="btn"
                v-if="step === 3"
                rounded
                 size="small"
                color="secondary"
                @click="(forceUpload) ? forUploadDialog = true : importCSV()"
                :disabled="disabledImport()"
                :loading="importLoading"
            >
                {{ (forceUpload) ? "Forcer la validation" : "Valider" }}
            </v-btn>
            <v-btn
                class="btn"
                v-else
                rounded
                 size="small"
                color="secondary"
                :disabled="!!foundErrors.length || emptyMessage !== ''"
                @click="step ++"
            >
                Suivant
            </v-btn>
        </v-card-actions> -->

        <oss-dialog
            v-model="forUploadDialog"
            title="Forcer la validation"
            @valid="
                importCSV();
                forUploadDialog = false;
            "
            :valid-loading="importLoading"
            valid-title="Oui"
            max-width="300"
        >
            <!-- <v-card-title class="headline">Forcer la validation</v-card-title> -->

            <v-card-text>Voulez-vous vraiment forcer la validation ?</v-card-text>

            <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn  size="small" color="blue en-1" text @click="forUploadDialog = false">Non</v-btn>
                <v-btn
                    color="blue en-1"
                    text
                    @click="importCSV(); forUploadDialog = false"
                    :loading="importLoading"
                >Oui</v-btn>
            </v-card-actions> -->
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment-timezone";
import OssDataTable from "../ossComponents/ossDataTable2.vue";
import ColumnCorrespondence from "@/views/import/ColumnCorrespondence.vue";
import { ImportDocumentBase } from "./ImportDocumentBase";
import UploadDocuments from "@/views/document/UploadDocuments.vue";

import { Apollo } from "@/decorators";
import { checkAmount } from "../../services/mathServices";
import { parseOFX } from "../../../../backend/src/common/import/ofxParser";
import { getDBFormattedDate } from "@/services/dateServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Ref } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

import CHECK_BANKTRANSACTIONS from "../../graphql/CheckBankTransactions.gql";
import IMPORT_BANKTRANSACTIONS from "../../graphql/ImportBankTransactions.gql";
import CREATE_DOCUMENT from "../../graphql/document/CreateDocument.gql";
// import FORCEIMPORT_BANKTRANSACTIONS from "../graphql/ForceImportBankTransactions.gql";
import BANK_ACCOUNTS from "../../graphql/bank/BankAccounts.gql";

@Component({
    components: {
        OssDataTable,
        ColumnCorrespondence,
        UploadDocuments,
    },
    emits: ["back", "width", "update:active", "documentImported"],
})
export class BankTransactionImport extends ImportDocumentBase {
    @Prop({ default: true }) readonly scanBank!: boolean;
    @Prop({ default: false }) readonly ofx!: boolean;
    @Prop({ default: "" }) readonly title: string;
    @Prop({ default: "" }) readonly selectedAccountId: string;
    @Prop() actions: any;

    @Ref("columnComponent") columnComponent;

    separator: string = "";

    fileName: string = "";
    isExcelFile: boolean;
    indexViewed = 0;
    step = 0;

    readingFinished: boolean = false;

    allDatesValid: boolean = true;

    accountingPeriod: any = null;
    startPeriodDate = "";

    amountWord = "";

    importLoading: boolean = false;

    stream = null;

    get balanceHeaders() {
        return [
            {
                text: "Description",
                value: "description",
                sortable: false,
                align: "center",
            },
            {
                text: "Date",
                value: "date",
                sortable: false,
                align: "center",
            },
            {
                text: "Montant",
                value: "amount",
                sortable: false,
                align: "center",
            },
            {
                text: "Différence",
                value: "difference",
                sortable: false,
                align: "center",
            },
        ];
    }

    ofxImport = [];
    ofxCounter = { length: 0, current: 0, preventDisabledImportFunc: false };
    get extensions() {
        if (this.ofx) {
            return ["ofx"];
        }
        return ["csv", "tsv", "txt", "xlsx", "xls"];
    }

    //
    // balance dates
    //
    minDate: string = "";
    maxDate: string = "";
    //
    existingLastBeforeBalanceDate = "";
    startBalanceBeforeDate = "";
    startBalanceDate = "";
    balanceDate: string = "";
    endBalanceDate = "";
    existingFirstAfterBalanceDate = "";
    //
    // balances
    //
    existingLastBeforeBalance: number = 0;
    startBalanceBefore: number = 0;
    startBalance: number = 0;
    balance: number = 0;
    endBalance: number = 0;
    existingFirstAfterBalance: number = 0;

    patternApplied = true;

    // Format de dates
    dateRegEx: Array<RegExp> = [
        /^(((0[13-9]|1[012])[-/]?(0[1-9]|[12][0-9]|30)|(0[13578]|1[02])[-/]?31|02[-/]?(0[1-9]|1[0-9]|2[0-8]))[-/]?[0-9]{4}|02[-/]?29[-/]?([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00))$/gi,
        /^(((0[1-9]|[12][0-9]|30)[-/]?(0[13-9]|1[012])|31[-/]?(0[13578]|1[02])|(0[1-9]|1[0-9]|2[0-8])[-/]?02)[-/]?[0-9]{4}|29[-/]?02[-/]?([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00))$/gi,
        /^([0-9]{4}[-/]?((0[13-9]|1[012])[-/]?(0[1-9]|[12][0-9]|30)|(0[13578]|1[02])[-/]?31|02[-/]?(0[1-9]|1[0-9]|2[0-8]))|([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00)[-/]?02[-/]?29)$/gi,
    ];

    beforeMount() {
        this.setActionsButton();
    }

    update = false;

    @Watch("step")
    setActionsButton() {
        if (this.actions && this.actions.action) {
            if (this.step === 0) {
                this.actions.action.display = true;
                this.actions.action.title = "Suivant";
                this.actions.action.disabled = () => {
                    return !this.existingFile;
                };
                this.actions.action.function = () => {
                    this.step++;
                };
                this.actions.action.previous = () => {
                    this.$emit("back");
                };
            } else if (this.step === 1) {
                if (this.ofx) {
                    const data = parseOFX(this.result.data, this.fileName);
                    this.ofxImport = data;
                    this.ofxCounter.length = data.length;
                    this.ofxCounter.current = 1;
                    this.onChosenColumns(data[0]);
                } else {
                    this.actions.action.display = true;
                    this.actions.action.title = "Suivant";
                    if (this.$refs.columnComponent) {
                        this.columnComponent.setActionButton();
                    }
                }

                this.actions.action.loading = () => {
                    return this.verifLoading;
                };
            } else if (this.step === 2) {
                this.actions.action.display = true;
                this.actions.action.title = "Suivant";
                this.actions.action.disabled = () => {
                    return (
                        !!this.foundErrors.length ||
                        this.emptyMessage !== "" ||
                        this.allDatesInvalid()
                    );
                };
                this.actions.action.function = () => {
                    this.step++;
                };
                this.actions.action.previous = () => {
                    this.step = this.ofx ? 0 : 1;
                };
                this.actions.action.loading = () => {
                    return false;
                };
            } else if (this.step === 3) {
                this.actions.action.display = true;
                this.actions.action.title = () => {
                    return this.forceUpload ? "Forcer la validation" : "Valider";
                };
                this.actions.action.disabled = () => {
                    return this.disabledImport();
                };
                this.actions.action.function = () => {
                    this.importCSV();
                };
                this.actions.action.previous = () => {
                    this.step--;
                };
                this.actions.action.loading = () => {
                    return this.importLoading;
                };
            }
        }
        this.$emit("width");
    }

    onBalanceDateChanged(date) {
        this.balanceDate = date;
    }

    get startBalanceDelta() {
        return this.startBalanceBefore - this.existingLastBeforeBalance;
    }

    get endBalanceDelta() {
        if (this.existingFirstAfterBalanceDate) {
            return this.existingFirstAfterBalance - this.endBalance;
        }
        return 0;
    }

    // event: any;

    // isHSBCImport = false

    key = 0;

    width = "80%";

    BTallreadyInDB: any;

    selected: Array<any> = [];

    getBC(item) {
        return item.isInDB ? "row-bc-selected" : "";
    }

    forceUpload = false;

    forUploadDialog = false;

    errors = {
        account: "Le compte bancaire n'a pas été sélectionné\n",
        failedBankTransactions: " mouvement(s) bancaire(s) ont déjà été importés",
        dates: "Certaines dates sont dans un exercise clos",
    };

    bankAccount: any = {
        id: "",
        name: "",
        startAuthorizedDate: "",
    };

    wrongFormat = false;

    foundErrors = [];

    get errorDescription() {
        if (!this.foundErrors.length) {
            return "";
        }
        let description = "";
        for (const error of this.foundErrors) {
            if (description) description += " - ";
            description += error.description + " (" + error.count + ")";
        }
        return description;
    }

    invalidDate(item) {
        const moments = [];
        if (item.date && moment(item.date).isValid()) {
            moments.push(moment(item.date, "DD/MM/YYYY").utc(true));
        }
        if (item.accountingDate && moment(item.accountingDate).isValid()) {
            moments.push(moment(item.accountingDate).utc(true));
        }
        const maxDate = moment.max(moments);
        if (this.bankAccount?.startAuthorizedDate) {
            const isValid = moment(maxDate).isSameOrBefore(this.bankAccount?.startAuthorizedDate);
            return isValid;
        }
        return false;
    }

    allDatesInvalid() {
        const dates = this.importedItems.map((item) => {
            return this.invalidDate(item);
        });
        return !dates.some((date) => !date);
    }

    formatDate(date) {
        if (!date) return "";
        return moment(date).format("DD/MM/YYYY");
    }

    wordings = [];
    formatBankTransactions() {
        this.importedItems = this.importedItems.map((item, index) => ({
            isInDB: false,
            id: index,
            isActive: false,
            ...item,
        }));
        this.wordings = this.importedItems.map((item, index) => ({
            wordingOriginal: item["wording"],
            amount: item["amount"],
            index: index,
        }));
    }

    async onChosenColumns(data) {
        const { importedItems } = data;
        const { foundErrors, analysedData, positions } = data;
        this.fileName = data.fileName;
        this.stream = data.stream;
        this.balance = analysedData?.balance || undefined;
        this.balanceDate = analysedData?.balanceDate || "";

        this.importedItems = importedItems;
        this.foundErrors = foundErrors;

        this.positions.amount = positions.amount || false;
        this.positions.dateRealization = positions.dateRealization || false;
        this.positions.accountingDate = positions.accountingDate || false;

        this.formatBankTransactions();
        if (this.importedItems.length) {
            this.verifLoading = true;
            const result = await this.verifyBankTransactions();
            if (result) {
                if (!this.foundErrors.length) {
                    if (!this.balanceDate && this.importedItems?.length) {
                        // console.log(this.importedItems[0].date);
                        this.balanceDate = moment(this.importedItems[0].date, "DD/MM/YYYY")
                            .add(-1, "days")
                            .format("YYYY-MM-DD");
                    }
                    this.selected = [...this.importedItems];
                    this.step = 2;
                    this.verifLoading = false;
                    this.setActionsButton();
                    this.ofxCounter.preventDisabledImportFunc = false;
                }
            }
        }
    }

    async verifyBankTransactions() {
        // debugger
        if (this.selectedCompany.id && this.importedItems?.length) {
            const query = await this.$apollo.query({
                query: gql`
                    query wordingAnalysis($companyId: ID, $wordings: Json!) {
                        wordingBTAnalysis(data: { companyId: $companyId, wordings: $wordings }) {
                            result
                        }
                    }
                `,
                fetchPolicy: "network-only",
                variables: {
                    companyId: this.selectedCompany.id,
                    wordings: this.wordings,
                },
            });
            const patternsFinded = query.data.wordingBTAnalysis.result;
            for (const res of patternsFinded) {
                this.importedItems[res.index] = {
                    ...this.importedItems[res.index],
                    pattern: res.pattern,
                    connectPattern: true,
                };
            }
            return true;
        }
        return false;
    }

    async onNewDocument() {
        const documentName = "";
        this.$apollo.mutate({
            mutation: CREATE_DOCUMENT,
            variables: {
                name: documentName,
                status: "VALIDATED",
                documentType: "BANK_STATEMENT",
                date: moment().format("YYYY-MM-DD"),
                companyId: this.selectedCompany.id,
                useForReconciliation: false,
                show: true,
                grossAmount: 0,
                grossAmountSigned: 0,
            },
        });
    }

    get errorItems() {
        return this.importedItems.filter((x) => x.isInDB);
    }

    initialize() {
        this.fileName = "";
        this.isExcelFile = false;
        // this.bankAccount = {
        //     id: "",
        //     name: ""
        // };
        this.importedItems = [];
        this.foundErrors = [];
        this.selected = [];
        this.failedBankTransactions = [];

        this.existingLastBeforeBalanceDate = "";
        this.startBalanceBeforeDate = "";
        this.startBalanceDate = "";
        this.endBalanceDate = "";
        this.existingFirstAfterBalanceDate = "";

        this.existingLastBeforeBalance = 0;
        this.startBalanceBefore = 0;
        this.startBalance = 0;
        this.balance = 0;
        this.endBalance = 0;
        this.existingFirstAfterBalance = 0;
    }
    /*
     * Procédure aprés validation
     */

    cleanAmount(amount) {
        if (!amount) return amount;
        const localAmount = amount.replace(" ", "");
        return localAmount.replace(",", ".").replace(/ /g, "");
    }

    disabledImport() {
        return (
            this.toDB.length === 0 ||
            // !this.startBalanceDate ||
            // Math.abs(this.startBalanceDelta) > 1e-1 ||
            // Math.abs(this.endBalanceDelta) > 1e-1 ||
            this.emptyMessage !== "" ||
            this.foundErrors.length > 0
        );
    }

    isSelected(item) {
        const result = this.selected.filter((x) => x.id === item.id);
        return result.length !== 0;
    }

    select(item) {
        if (this.isSelected(item)) {
            this.selected = this.selected.filter((x) => x.id !== item.id);
        } else {
            this.selected.push(item);
        }
    }

    async importCSV() {
        // debugger
        this.importLoading = true;

        if (
            this.emptyMessage === "" &&
            !this.wrongFormat &&
            this.foundErrors.length === 0 &&
            this.bankAccount &&
            this.bankAccount.id
        ) {
            // Si l'upload n'a jamais été fait sur ce fichier, on upload les lignes sélectionnées
            this.key++;
            // console.table(this.toDBCompute())
            const result = await this.$apollo.mutate({
                mutation: IMPORT_BANKTRANSACTIONS,
                variables: {
                    companyId: this.selectedCompany.id,
                    bankAccountId: this.bankAccount.id,
                    bankTransactions: this.toDBCompute(),
                    balance: this.balance || null,
                    balanceDate: this.balanceDate?.length
                        ? getDBFormattedDate(this.balanceDate)
                        : "",
                    stream: this.stream,
                    fileName: this.fileName,
                },
            });

            // Retour des valeurs déjà dans la base de données pour affichage
            if (result?.data?.bankTransactionImport?.failedBankTransactions) {
                const isInDB = result.data.bankTransactionImport.failedBankTransactions;
                this.selected = this.selected.splice(0, this.selected.length);

                for (let i = this.importedItems.length - 1; i >= 0; i--) {
                    if (isInDB.indexOf(i) === -1) {
                        this.importedItems.splice(i, 1);
                    }
                }
            } else {
                console.error("ERROR");
            }
        }
        this.importLoading = false;

        if (this.ofx && this.ofxImport.length > 1 && this.importedItems.length === 0) {
            this.ofxCounter.preventDisabledImportFunc = true;
            this.initialize();
            this.ofxImport.splice(0, 1);
            this.onChosenColumns(this.ofxImport[0]);
            this.ofxCounter.current++;
        }
        if (this.importedItems.length === 0) {
            this.$emit("documentImported");
            if (this.importedItems.length === 0) {
                this.$emit("update:active", false);
            }
        }
    }

    // @Watch("balance")
    // @Watch("balanceDate")
    // @Watch("selected")
    // async onChanged() {
    //     this.computeToDB();
    // }

    // toDB: Array<any> = [];

    get positions() {
        const positions: any = {
            amount: false,
            dateRealization: false,
            accountingDate: false,
        };
        return positions;
    }

    get positionMessage() {
        return "";
    }

    get emptyMessage() {
        let emptyMessage = "";

        if (!this.bankAccount.id) {
            emptyMessage += emptyMessage ? ", " : "" + this.errors.account;
        }
        if (this.failedBankTransactions?.length) {
            emptyMessage += emptyMessage
                ? ", "
                : "" + this.failedBankTransactions.length + this.errors.failedBankTransactions;
        }
        if (!this.allDatesValid) {
            emptyMessage += emptyMessage ? ", " : "" + this.errors.dates;
        }
        return emptyMessage;
    }

    getAmount(item) {
        if (item["amount"]) {
            return item["amount"];
        }
        if (item["credit"]) {
            const amountS = this.cleanAmount(item["credit"]);
            if (amountS) {
                if (checkAmount(amountS)) {
                    const amount = parseFloat(amountS);
                    if (amount) {
                        return amount;
                    }
                }
            }
        }
        if (item["debit"]) {
            const amountS = this.cleanAmount(item["debit"]);
            if (amountS) {
                if (checkAmount(amountS)) {
                    const amount = parseFloat(amountS);
                    if (amount) {
                        return -amount;
                    }
                }
            }
        }
        return "XXX";
    }

    addError(key, description) {
        const error = this.foundErrors.find((e) => e.key === key);
        if (error) {
            error.count++;
        } else {
            this.foundErrors.push({
                key,
                description,
                count: 1,
            });
        }
    }

    get toDB() {
        const toDB: Array<any> = [];
        if (this.step < 2 || this.ofxCounter.preventDisabledImportFunc) {
            // return toDB;
            // this.toDB.splice(0, this.toDB.length);
            return toDB;
        }
        this.foundErrors = [];
        if (this.positionMessage === "") {
            this.minDate = "";
            this.maxDate = "";
            let minDate = null;
            let maxDate = null;
            // this.selected.forEach((select:any) => {
            for (const select of this.selected) {
                let amount: number;
                if (this.positions.amount) {
                    const amountS = this.cleanAmount(select["amount"]);
                    if (!checkAmount(amountS)) {
                        this.addError(
                            "amount",
                            "Les colonnes des montants ne sont pas correctement définies",
                        );
                    } else {
                        amount = parseFloat(amountS);
                    }
                } else {
                    const credit = this.cleanAmount(select["credit"]);
                    const debit = this.cleanAmount(select["debit"]);

                    amount = 0;
                    if (credit) {
                        if (!checkAmount(credit)) {
                            this.addError("credit", "Le crédit n'est pas au bon format");
                        } else {
                            amount = parseFloat(credit);
                        }
                    }
                    if (debit) {
                        if (!checkAmount(debit)) {
                            this.addError("debit", "Le débit n'est pas au bon format");
                        } else {
                            amount -= parseFloat(debit);
                        }
                    }
                }

                const date = this.toDate(select["date"]);
                if (select["date"]) {
                    if (!date.isValid()) {
                        this.addError("date", "La date n'est pas au bon format");
                    }
                    if (!minDate && !maxDate) {
                        minDate = date;
                        maxDate = date;
                    } else {
                        if (minDate.isAfter(date)) minDate = date;
                        if (maxDate.isBefore(date)) maxDate = date;
                    }
                }
                const accountingDate = select["accountingDate"]?.length
                    ? this.toDate(select["accountingDate"])
                    : date;
                toDB.push({
                    amount: amount,
                    dateDebit: getDBFormattedDate(date),
                    accountingDate: getDBFormattedDate(accountingDate),
                    dateRealization: getDBFormattedDate(date),
                    wordingOriginal: select["wording"],
                    wordingSimplified: select["wording"],
                    pattern: select.connectPattern ? select.pattern : undefined,
                });
            }
            if (!toDB.length) {
                this.addError("bankTransaction", "Aucune ligne bancaire trouvée");
            }
            if (minDate) {
                this.minDate = moment(minDate).format("YYYY-MM-DD");
            }
            if (maxDate) {
                this.maxDate = maxDate.format("YYYY-MM-DD");
            }
        }
        return toDB;
    }

    toDBCompute() {
        const toDB: Array<any> = [];
        if (!this.fileName) {
            // return toDB;
            // this.toDB.splice(0, this.toDB.length);
            return toDB;
        }

        if (this.positionMessage === "") {
            this.maxDate = "";
            let minDate = null;
            let maxDate = null;
            // this.selected.forEach((select:any) => {

            for (const select of this.selected) {
                let amount: number;
                if (this.positions.amount) {
                    amount = parseFloat(this.cleanAmount(select["amount"]));
                } else {
                    amount = 0.0;
                    if (select["credit"]) {
                        amount = parseFloat(this.cleanAmount(select["credit"]));
                    }
                    if (select["debit"]) {
                        amount -= parseFloat(this.cleanAmount(select["debit"]));
                    }
                }

                const date = this.toDate(select["date"]);
                let dateRealization;
                if (this.positions.dateRealization) {
                    dateRealization = this.toDate(select["dateRealization"]);
                } else {
                    dateRealization = date;
                }
                let accountingDate;
                if (this.positions.accountingDate) {
                    accountingDate = this.toDate(select["accountingDate"]);
                }
                if (!minDate && !maxDate) {
                    minDate = date;
                    maxDate = date;
                } else {
                    if (minDate.isAfter(date)) minDate = date;
                    if (maxDate.isBefore(date)) maxDate = date;
                }
                if (select["wording"]) {
                    toDB.push({
                        amount: amount,
                        dateDebit: getDBFormattedDate(date),
                        accountingDate: getDBFormattedDate(accountingDate),
                        dateRealization: getDBFormattedDate(dateRealization),
                        wordingOriginal: select["wording"],
                        wordingSimplified: select["wording"],
                        pattern: select.connectPattern ? select.pattern : undefined,
                    });
                }
            }

            this.minDate = getDBFormattedDate(moment(minDate));
            this.maxDate = getDBFormattedDate(maxDate);
        }
        return toDB;
    }

    /*
     * Récupération des tous les comptes de l'utilisateur
     */
    @Apollo({
        query: BANK_ACCOUNTS,
        variables() {
            return {
                companyId: this.selectedCompany.id,
                type: "BANK",
            };
        },
        skip() {
            return !this.selectedCompany;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.bankAccounts) {
                    this.bankAccounts = data.bankAccounts;
                    this.initialize();
                    if (this.bankAccounts.length) {
                        const selectedBankAccount = this.bankAccounts.find(
                            (ba) => ba.id === this.selectedAccountId,
                        );
                        if (selectedBankAccount) {
                            this.bankAccount = selectedBankAccount;
                        } else {
                            this.bankAccount = this.bankAccounts[0];
                        }
                    }
                }
            }
        },
    })
    bankAccounts = [];

    @Apollo({
        query: CHECK_BANKTRANSACTIONS,
        variables() {
            return {
                bankAccountId: this.bankAccount && this.bankAccount.id ? this.bankAccount.id : null,
                bankTransactions: this.toDB,
                balance: this.balance ? this.balance : undefined,
                balanceDate: this.balanceDate
                    ? moment(this.balanceDate).format("YYYY-MM-DD")
                    : undefined,
            };
        },
        skip() {
            return (
                !this.toDB.length ||
                this.bankAccount.id === "" ||
                this.positionMessage ||
                this.step <= 2 ||
                this.foundErrors.length
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            // this.loading = loading
            if (!loading) {
                if (data && data.checkBankTransactions) {
                    if (data.checkBankTransactions.balances) {
                        const balances = data.checkBankTransactions.balances;
                        if (balances.startBefore) {
                            this.startBalanceBefore = balances.startBefore.balance;
                            this.startBalanceBeforeDate = balances.startBefore.date;
                        } else {
                            this.startBalanceBefore = 0;
                            this.startBalanceBeforeDate = "";
                        }
                        if (balances.start) {
                            this.startBalance = balances.start.balance;
                            this.startBalanceDate = balances.start.date;
                        } else {
                            this.startBalance = 0;
                            this.startBalanceDate = "";
                        }
                        if (balances.end) {
                            this.endBalance = balances.end.balance;
                            this.endBalanceDate = balances.end.date;
                        } else {
                            this.endBalance = 0;
                            this.endBalance = "";
                        }
                        if (balances.existingFirstAfterBalance) {
                            this.existingFirstAfterBalance =
                                balances.existingFirstAfterBalance.balance;
                            this.existingFirstAfterBalanceDate =
                                balances.existingFirstAfterBalance.date;
                        } else {
                            this.existingFirstAfterBalance = 0;
                            this.existingFirstAfterBalanceDate = "";
                        }
                        if (balances.existingLastBeforeBalance) {
                            this.existingLastBeforeBalance =
                                balances.existingLastBeforeBalance.balance;
                            this.existingLastBeforeBalanceDate =
                                balances.existingLastBeforeBalance.date;
                        } else {
                            this.existingLastBeforeBalance = 0;
                            this.existingLastBeforeBalanceDate = "";
                        }
                        if (balances.balance) {
                            this.balance = balances.balance.balance;
                            this.balanceDate = balances.balance.date;
                        }
                    }
                    this.failedBankTransactions =
                        data.checkBankTransactions.failedBankTransactions || [];
                    this.selected = this.selected.filter(
                        (x) => !data.checkBankTransactions.failedBankTransactions?.includes(x.id),
                    );

                    for (let i = this.importedItems.length - 1; i >= 0; i--) {
                        const item = this.importedItems[i];
                        if (this.failedBankTransactions.indexOf(i) !== -1) {
                            item.isInDB = true;
                        } else {
                            item.isInDB = false;
                        }
                    }
                }
            }
        },
    })
    failedBankTransactions = [];

    processBankTransaction(headers, itemsCorrespondance, separator) {
        const rawData = [];
        let preProcessItemCorrespondence = undefined;
        let preProcessHeaderCorrespondence = undefined;
        let preProcessItemSelection = undefined;

        let balance = 0;
        let balanceDate = "";

        const isHSBCImport = headers.includes("Code Op�ration HSBC");
        if (isHSBCImport) {
            const bank = { ...itemsCorrespondance[0] };
            balance = parseFloat(bank.Montant.replace(/ /gi, "").replace(",", "."));
            balanceDate = moment(bank["Date d'op�ration"], "DD/MM/YYYY").format("YYYY-MM-DD");
            preProcessItemCorrespondence = itemsCorrespondance.filter(
                (x) =>
                    x["Code Enregistrement"] === "04" ||
                    x["Code Enregistrement"] === "05" ||
                    x["Code Enregistrement"] === "4" ||
                    x["Code Enregistrement"] === "5",
            );
            let currentIndex = 0;
            let index = 0;
            while (index < preProcessItemCorrespondence.length) {
                if (
                    preProcessItemCorrespondence[index]["Code Enregistrement"] === "05" ||
                    preProcessItemCorrespondence[index]["Code Enregistrement"] === "5"
                ) {
                    preProcessItemCorrespondence[currentIndex]["Libell�"] =
                        preProcessItemCorrespondence[currentIndex]["Libell�"] +
                        " " +
                        preProcessItemCorrespondence[index]["Libell�"];
                } else {
                    currentIndex = index;
                }
                index++;
            }
            preProcessItemCorrespondence = preProcessItemCorrespondence
                .filter(
                    (x) => x["Code Enregistrement"] === "04" || x["Code Enregistrement"] === "4",
                )
                .map((x) => ({
                    dateRealization: x["Date d'op�ration"],
                    date: x["Date de valeur"],
                    wording: x["Libell�"],
                    amount: x.Montant,
                }));
            preProcessItemSelection = [
                { type: "dateRealization", value: "v0" },
                { type: "date", value: "v1" },
                { type: "wording", value: "v2" },
                { type: "amount", value: "v3" },
            ];
            preProcessHeaderCorrespondence = [
                {
                    text: "Date de réalisation",
                    value: "dateRealization",
                    align: "center",
                    sortable: false,
                },
                { text: "Date", value: "date", align: "center", sortable: false },
                { text: "Libellé", value: "wording", align: "center", sortable: false },
                { text: "Montant", value: "amount", align: "center", sortable: false },
            ];
            rawData[0] = ["dateRealization", "date", "wording", "amount"];
            preProcessItemCorrespondence.map((item) => {
                let line = item.dateRealization ? item.dateRealization : "";
                line += separator;
                line += item.date ? item.date : "";
                line += separator;
                line += item.wording ? item.wording : "";
                line += separator;
                line += item.amount ? '"' + item.amount + '"' : "";
                rawData.push(line);
            });
        } else if (this.scanBank) {
            preProcessItemCorrespondence = itemsCorrespondance
                .filter((x) => x.v2.startsWith("512"))
                .map((x) => ({
                    date: x.v0,
                    credit: x.v3,
                    debit: x.v4,
                    wording: x.v1 !== x.v13 ? x.v1 + " " + x.v13 : x.v1,
                }));
            preProcessItemSelection = [
                { type: "date", value: "v0" },
                { type: "credit", value: "v1" },
                { type: "debit", value: "v2" },
                { type: "wording", value: "v3" },
            ];
            preProcessHeaderCorrespondence = [
                { text: "Date", value: "date", align: "center", sortable: false },
                { text: "Crédit", value: "credit", align: "center", sortable: false },
                { text: "Débit", value: "debit", align: "center", sortable: false },
                { text: "Libellé", value: "wording", align: "center", sortable: false },
            ];
            rawData[0] = ["date", "wording", "credit", "debit"];
            preProcessItemCorrespondence.map((item) => {
                let line = item.date ? item.date : "";
                line += separator;
                line += item.wording ? item.wording : "";
                line += separator;
                line += item.debit ? '"' + item.debit + '"' : "";
                line += separator;
                line += item.credit ? '"' + item.credit + '"' : "";
                rawData.push(line);
            });
        }
        return {
            rawData: rawData.length ? rawData : undefined,
            preProcessItemCorrespondence,
            preProcessHeaderCorrespondence,
            preProcessItemSelection,
            processedData: {
                balance,
                balanceDate,
            },
            success: true,
        };
    }

    /*
     * Transforme un string en un format de date valide
     */

    toDate(string: string) {
        // debugger
        const result = moment(string, [
            "DD/MM/YYYY",
            "DD-MM-YYYY",
            "YYYY/MM/DD",
            "YYYY-MM-DD",
            "DDMMYYYY",
        ]);
        if (!result.isValid()) {
            debugger;
        }
        return result;
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }
}

export default toNative(BankTransactionImport);
</script>

<style lang="scss" scoped>
.balance-border-top {
    border-top: solid 1px #c1c1c1;
}
.balance-border-bottom {
    border-bottom: solid 1px #c1c1c1;
}

.row-bc-selected {
    background-color: #ffcdd2 !important;
}
</style>
